import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from 'antd';
import UIComponent from './uiComponent';
import { DynamicIcon } from './utils';
function UIIconButtonComponent(props) {
    return (_jsx(Button, { type: 'primary', style: {
            backgroundColor: props.iconType === 'CloseOutlined' ? '#c00000' : props.iconType === 'DownloadOutlined' ? '#1f7d3d' : '#ffffff',
            color: props.iconType === 'CloseOutlined' || props.iconType === 'DownloadOutlined' ? '#ffffff' : '#000000',
            border: props.iconType === 'CloseOutlined' || props.iconType === 'DownloadOutlined' ? '1px solid #ffffff' : ' 1px solid #000000',
        }, onClick: props.onClick, icon: _jsx(DynamicIcon, { iconName: props.iconType }) }));
}
export default class UIIconButton extends UIComponent {
    iconType;
    onClick;
    constructor(s) {
        super(s);
        this.iconType = this.getProperty('iconType', 'CloseOutlined');
    }
    getComponent() {
        const props = {
            iconType: this.iconType,
            onClick: () => {
                this.onClick();
            },
        };
        return _jsx(UIIconButtonComponent, { ...props }, this.name);
    }
}
//# sourceMappingURL=uiIconButton.js.map